import type { DesignationOperateurServicesEssentiels } from '../../ChampsSimulateur.definitions.js';
import { contientUnParmi } from '../../commun.predicats.js';
import type { EtatQuestionnaire } from '../../EtatQuestionnaire.js';
import type { SpecificationTexte } from '../FormatDesSpecificationsCSV.js';
import type { Regle } from '../Specifications.js';
import { ErreurLectureDeRegle } from './ErreurLectureDeRegle.js';

export class RegleEntiteOSE implements Regle {
  constructor(private readonly valeursAcceptees: DesignationOperateurServicesEssentiels[]) {}

  evalue(etat: EtatQuestionnaire) {
    return contientUnParmi(...this.valeursAcceptees)(etat.designationOperateurServicesEssentiels);
  }

  static nouvelle(texte: SpecificationTexte): RegleEntiteOSE | undefined {
    const valeur = texte['Designation OSE'];

    if (!valeur) return;
    if (valeur === 'Oui') return new RegleEntiteOSE(['oui']);
    if (valeur === 'Non') return new RegleEntiteOSE(['non']);
    if (valeur === 'Ne sait pas') return new RegleEntiteOSE(['nsp']);
    if (valeur === 'Non [OU] Ne sait pas') return new RegleEntiteOSE(['non', 'nsp']);

    throw new ErreurLectureDeRegle(valeur, 'Designation OSE');
  }
}
